import { useState, useCallback, useMemo } from "react";
import CardWithHeaderTemplate from "../components/cardWithHeaderTemplate";
import Template from "../components/template";
import HeaderView from "./components/HeaderView";
import Statistics from "./components/Statistics";
import Table from "./components/Table";
import PaginationView from "./components/PaginationView";

const Financial = () => {
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [totalJobs, setTotalJobs] = useState(0);
    const [filters, setFilters] = useState({
        dateRange: null,
        selectedFtm: null
    });

    const handlePageChange = useCallback((newPage) => {
        setPage(newPage);
    }, []);

    const handleSetDateFilter = useCallback((dateRange) => {
        setFilters((prev) => ({ ...prev, dateRange }));
        setPage(1); // reset pagination
    }, []);

    const handleSetSelectedFtm = useCallback((ftm) => {
        setFilters((prev) => ({ ...prev, selectedFtm: ftm }));
        setPage(1);
    }, []);

    const header = useMemo(() => (
        <HeaderView
            selectedFtm={filters.selectedFtm}
            selectedDateRange={filters.dateRange}
            totalJobs={totalJobs}
            setSelectedFtm={handleSetSelectedFtm}
            setDateFilter={handleSetDateFilter}
        />
    ), [filters.selectedFtm, filters.dateRange, totalJobs, handleSetSelectedFtm, handleSetDateFilter]);

    const body = useMemo(() => (
        <Table
            selectedFtm={filters.selectedFtm}
            dataFilter={filters.dateRange}
            page={page}
            setTotalPages={setTotalPages}
            setTotalJobs={setTotalJobs}
        />
    ), [filters.selectedFtm, filters.dateRange, page]);

    const footer = useMemo(() => (
        <PaginationView
            totalPages={totalPages}
            page={page}
            onPageChange={handlePageChange}
        />
    ), [totalPages, page, handlePageChange]);

    return (
        <Template>
            <div className="container-fluid py-4">
                <div className="row">
                    <div className="col-12">

                        <Statistics
                            selectedFtm={filters.selectedFtm}
                            dataFilter={filters.dateRange}
                        />

                        <CardWithHeaderTemplate
                            header={header}
                            body={body}
                            footer={footer}
                        />

                    </div>
                </div>
            </div>
        </Template>
    );
};

export default Financial;